<template>
  <div class="content-warp">
    <div class="content-panle bg-white">
      <div class="table-operation-area">
        <div class="btn-area-inline">
          <TableTips :total="pagination.total" />
        </div>
        <a-form class="search-form" layout="inline" :form="listSearchForm" @submit.prevent="handleSearchList">
          <a-form-item>
            <a-select
              style="width: 160px"
              :placeholder="$t('warningMana.warningTypeTxt')"
              :options="searchWarningTypeOptions"
              v-decorator="['warningType', { initialValue: '' }]"
            />
          </a-form-item>

          <a-form-item>
            <a-range-picker
              style="width: 280px"
              format="YYYY-MM-DD"
              :placeholder="[$t('warningMana.startTimeTxt'), $t('warningMana.endTimeTxt')]"
              :ranges="searchDateRangesBtn"
              v-decorator="['dateRange', {initialValue: [moment(), moment()]}]"
              :disabledDate="current => current > moment()"
            />
          </a-form-item>                

          <a-form-item>
            <a-input 
              style="width: 160px"
              type="text"
              v-decorator="['keyword']" 
              :placeholder="$t('warningMana.deviceSNOrNameTxt')" >
              <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>

          <a-form-item style="margin-right:0">
            <a-button type="primary" html-type="submit" :loading="loading">{{$t('warningMana.searchBtn')}}</a-button>
          </a-form-item>
        </a-form>
      </div>
      
      <a-table 
        class="table-area"
        style="min-height: 584px"
        :columns="tableColumns" 
        :dataSource="tableData"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <div slot="scenePhoto" slot-scope="text, record">
          <img @click="handleShowImg" :src="record.scenePhoto" alt="现场照" style="height: 100px;cursor: pointer;">
        </div>
        <div slot="blackPhoto" slot-scope="text, record">
          <img v-if="record.blackPhoto" @click="handleShowImg" :src="record.blackPhoto" alt="黑名单人脸照" style="height: 100px;cursor: pointer;">
          <span v-else>--</span>
        </div>
      </a-table>
    </div>

    <!-- 查看照片 -->
    <a-modal
      class="show-img-modal"
      :title="$t('warningMana.sitePhotoModalTitle')"
      :footer="null"
      :visible="showImgModalVisible"
      @cancel="()=>{showImgModalVisible=false}"
      :afterClose="()=>{showImgUrl=''}"
    >
      <a-card style="width: 100%;">
        <img
          slot="cover"
          alt="example"
          :src="showImgUrl"
        />
      </a-card>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { getWarnings } from '@/api/warningMana';
import TableTips from '@/components/TableTips';
export default {
  name: 'warningManaIndex',
  components: { TableTips },
  data() {
    return {

      listSearchForm: this.$form.createForm(this),

      searchWarningTypeOptions: [],

      searchWarningType: '',
      searchKeyword: '',
      searchFromDate: moment().format('YYYY-MM-DD'),
      searchToDate: moment().format('YYYY-MM-DD'),
      searchDateRangesBtn: this.getSearchDateRangesBtn(),

      loading: false, // 列表内容是否在加载中
      tableData: [], // 列表数据源
      tableColumns: this.getTableColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      showImgModalVisible: false,
      showImgUrl: ''
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      warningType: state => state.enumsStore.enumsData.warningType
    })
  },
  watch: {
    lang: function (lang) {
      this.tableColumns = this.getTableColumns()
      this.searchDateRangesBtn = this.getSearchDateRangesBtn()
      this.searchWarningTypeOptions = [].concat([{ title: this.$t('warningMana.option_allType'), value: '', key: 'all' }], this.warningType);
    }
  },
  created() {
    this.searchWarningTypeOptions = [].concat([{ title: this.$t('warningMana.option_allType'), value: '', key: 'all' }], this.warningType);

    this.getListData();
  },
  methods: {
    moment,
    getTableColumns() {
      return [
        {
          title: this.$t('warningMana.listWarningType'),
          dataIndex: 'warningTypeName',
          width: '10%'
        },
        {
          title: this.$t('warningMana.listDeviceSN'),
          dataIndex: 'deviceSn',
          width: '16%'
        },
        {
          title: this.$t('warningMana.listDeviceName'),
          dataIndex: 'deviceName',
          width: '15%'
        },
        {
          title: this.$t('warningMana.listSitePhotos'),
          dataIndex: 'scenePhoto',
          width: '12%',
          scopedSlots: { customRender: 'scenePhoto' }
        },
        {
          title: this.$t('warningMana.listBlacklistPhoto'),
          dataIndex: 'blackPhoto',
          width: '14%',
          scopedSlots: { customRender: 'blackPhoto' }
        },
        {
          title: this.$t('warningMana.listBlacklistRemark'),
          dataIndex: 'blackRemark',
          width: '14%'
        },
        {
          title: this.$t('warningMana.listWarningTime'),
          dataIndex: 'warningAt',
          width: '19%'
        }  
      ]
    },
    // 获取时间段选择插件快捷按钮内容
    getSearchDateRangesBtn() {
      const btns = {}
      btns[this.$t('warningMana.aWeekBeforeBtn')] = [this.moment().subtract(6, 'days'), this.moment()]
      btns[this.$t('warningMana.oneMonthBeforeBtn')] = [this.moment().subtract(1, 'months'), this.moment()]
      btns[this.$t('warningMana.threeMonthsBeforeBtn')] = [this.moment().subtract(3, 'months'), this.moment()]
      return btns
    },
    // 搜素列表
    handleSearchList() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          // console.log('handleSearchList', values);

          this.searchWarningType = values.warningType;
          this.searchKeyword = values.keyword;
          this.searchFromDate = values.dateRange[0].format('YYYY-MM-DD');
          this.searchToDate = values.dateRange[1].format('YYYY-MM-DD');

          this.pagination.current = 1;
          this.getListData();
        }
      });
    },
    // 获取列表数据
    async getListData() {
      try {
        this.loading = true;
        const res = await getWarnings({
          warningType: this.searchWarningType,
          fromDate: this.searchFromDate,
          toDate: this.searchToDate,
          keyword: this.searchKeyword,
          perPage: this.pagination.pageSize,
          page: this.pagination.current
        })
        this.loading = false;

        this.tableData = this.createWarningTableData(res.data.collection);        
        this.pagination.total = res.data.size;
      } catch (error) {
        this.loading = false;
      }
    },
    createWarningTableData(data) {
      return data.map(item => {
        return {
          key: Math.random(),
          id: Math.random(),
          warningTypeName: item.warningTypeName,
          deviceSn: item.deviceSn,
          deviceName: item.deviceName,
          scenePhoto: item.scenePhotoUrl,
          blackPhoto: item.blackListPhotoUrl,
          blackRemark: item.blackListRemark || '--',
          warningAt: item.warningAt
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      // console.log('-------handleTableChange------', pagination);
      this.pagination.current = pagination.current;
      this.getListData();
    },

    // 查看列表图片
    handleShowImg(e) {
      this.showImgUrl = e.target.src;
      this.showImgModalVisible = true;
    }
  }
  
}
</script>

<style scoped>
  .show-img-modal .ant-modal{
    top: 30px
  }
</style>